/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Flickity from "flickity";
import VanillaTilt from "vanilla-tilt";
import Isotope from "isotope-layout";
import lottie from "lottie-web";

const HTML = document.querySelector("html");

gsap.registerPlugin(ScrollTrigger);

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** Toggle menu */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** Active banner header */
    const mainHeader = document.querySelector(".main-header");
    if (mainHeader) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > mainHeader.offsetHeight) {
          HTML.classList.add("show-banner");
        } else {
          HTML.classList.remove("show-banner");
        }
      });
    }
    window.dispatchEvent(new Event("scroll"));

    /** URL select */
    const selects = document.querySelectorAll(".url-select");
    if (selects) {
      selects.forEach((select) => {
        select.addEventListener("change", () => {
          window.location.href = select.value;
        });
      });
    }

    this.cover();
    this.tilt();
    this.accordion();
    this.carousel();
    this.marquee();
    this.parallaxHover();
    this.randomizeFocus();
    this.hoverThumbs();
    this.tabs();
    this.gifAnimation();
    this.multipleTabs();
    this.gridIsotope();
    this.loadMore();
    this.bodymovin();
    this.inViewport();
  }

  loadMore() {
    const elts = document.querySelectorAll(".load-more");

    if (elts) {
      elts.forEach((el) => {
        const list = document.querySelector(el.dataset.container);
        const labelBtn = el.querySelectorAll(".label");

        if (!el || !list) return;

        el.addEventListener("click", async () => {
          const nextPage = Number(el.dataset.page) + 1;
          const maxPages = Number(el.dataset.maxPages);

          el.disabled = true;
          labelBtn.forEach((label) => (label.textContent = "Chargement..."));

          const formData = new FormData();
          formData.append("action", "load_more_posts");
          formData.append("page", nextPage);

          try {
            const response = await fetch(
              window.ajaxurl || "/wp-admin/admin-ajax.php",
              {
                method: "POST",
                body: formData,
              }
            );

            if (!response.ok) {
              throw new Error("Erreur HTTP");
            }

            const html = await response.text();

            if (html.trim()) {
              list.insertAdjacentHTML("beforeend", html);
              el.dataset.page = nextPage;

              this.lazyload.update();
              this.inViewport();
            }

            if (!html.trim() || nextPage >= maxPages) {
              el.remove();
            } else {
              el.disabled = false;
              labelBtn.forEach(
                (label) => (label.textContent = "plus d'articles")
              );
            }
          } catch (error) {
            console.error(error);
            el.disabled = false;
            labelBtn.forEach((label) => (label.textContent = "Réessayer"));
          }
        });
      });
    }
  }


  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: !(
                    tag.dataset.bodymovinAutoplay &&
                    tag.dataset.bodymovinAutoplay != "0"
                  ),
                  path: anim,
                });
                l.addEventListener("loaded_images", () => {
                  tag.classList.add("loaded");
                });
                tag.lottie = l;

                if (
                  tag.dataset.bodymovinAutoplay &&
                  tag.dataset.bodymovinAutoplay != ""
                ) {
                  setTimeout(() => {
                    l.play();
                    tag.classList.add("loaded");
                  }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1000);
                } else {
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  tilt() {
    const elts = document.querySelectorAll(".js-tilt");

    if (elts) {
      elts.forEach((el) => {
        VanillaTilt.init(el, {
          max: 14,
          speed: 200,
          "mouse-event-element": el.dataset.tiltTrigger
            ? el.dataset.tiltTrigger
            : null,
        });
      });
    }
  }

  cover() {
    const elts = document.querySelectorAll(".cover:not(.is-preview)");

    if (elts) {
      elts.forEach((el) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top top",
            end: `+=${window.innerHeight * 2}`,
            scrub: 1.2,
            pin: true,
            marker: true,
          },
        });

        const BM = el.querySelector(".bm");
        if (BM) {
          tl.to(
            BM,
            {
              top: "50%",
              // autoAlpha: 0,
              duration: 1,
              ease: "none",
              scale: 1,
              // scale: 1.2,
              // y: "30%",
            },
            0
          );
        }

        const content = el.querySelector(".content");
        if (content) {
          tl.to(
            content,
            {
              width: "100%",
              height: "100%",
              borderRadius: 0,
              duration: 0.15,
              ease: "none",
            },
            0
          );
        }

        const items = el.querySelectorAll(".item");
        items.forEach((el) => {
          const depth = Number.parseFloat(el.dataset.depth || 1);

          const factorX = Number.parseFloat(el.dataset.x || 0);
          const factorY = Number.parseFloat(el.dataset.y || 0);

          const width = el.offsetWidth;
          const height = el.offsetHeight;

          // 💡 mouvement basé sur la taille
          const moveX = width * factorX * depth;
          const moveY = height * factorY * depth;

          const scale = 1 + depth * (el.dataset.zoom || 0.3);
          const blur = depth * (el.dataset.blur || 6);
          const delay = depth * el.dataset.delay;

          const isIncoming = el.classList.contains("new");

          const bottom = el.dataset.bottom ? el.dataset.bottom : "";
          const left = el.dataset.left ? el.dataset.left : "";
          const right = el.dataset.right ? el.dataset.right : "";
          const top = el.dataset.top ? el.dataset.bottom : "";

          /* === SORTIE === */
          if (!isIncoming) {
            tl.to(
              el,
              {
                x: moveX,
                y: moveY,
                scale,
                opacity: el.dataset.opacity ? el.dataset.opacity : 1,
                filter: `blur(${blur}px)`,
                ease: "none",
                bottom,
                left,
                top,
                right,
                duration: el.dataset.duration
                  ? Number.parseFloat(el.dataset.duration)
                  : 1,
              },
              delay
            );
          }

          /* === ENTRÉE === */
          if (isIncoming) {
            tl.fromTo(
              el,
              {
                x: moveX * -0.3,
                y: moveY * -0.3,
                scale: depth * (el.dataset.zoom || 0.3),
                opacity: 0,
                filter: `blur(${blur}px)`,
              },
              {
                x: 0,
                y: 0,
                scale: 1,
                opacity: 1,
                filter: "blur(0px)",
                ease: "none",
                duration: el.dataset.duration
                  ? Number.parseFloat(el.dataset.duration)
                  : 1,
              },
              delay
            );
          }
        });
      });
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts) {
      elts.forEach((el) => {
        const items = el.querySelectorAll(".item > *");
        const flkty = new Flickity(el, {
          pageDots: false,
          contain: true,
          watchCSS: true,
          groupCells: true,
          cellAlign: "left",
        });

        window.addEventListener("resize", () => {
          if (flkty && flkty.cells) {
            let maxHeight = 0;
            gsap.set(items, { clearProps: "all" });
            flkty.cells.forEach(function (cell) {
              if (cell.element.scrollHeight > maxHeight)
                maxHeight = cell.element.scrollHeight;
            });
            gsap.set(items, {
              height: maxHeight,
            });
          }
        });
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  gridIsotope() {
    const elts = document.querySelectorAll(".grid-isotope");

    if (elts) {
      elts.forEach((el) => {
        const iso = new Isotope(el, {
          // options
          itemSelector: ".item",
          layoutMode: "masonry",
        });

        const filters = el.dataset.filter
          ? document.querySelectorAll(`${el.dataset.filter}`)
          : false;

        if (filters) {
          filters.forEach((filter) => {
            if (filter.tagName == "SELECT") {
              filter.addEventListener("change", () => {
                iso.arrange({
                  filter: filter.value,
                });
              });
            } else {
              const triggers = filter.querySelectorAll("a");

              triggers.forEach((trigger) => {
                trigger.addEventListener("click", (e) => {
                  e.preventDefault();
                  if (trigger.classList.contains("active")) return;

                  triggers.forEach((f) => f.classList.remove("active"));
                  trigger.classList.add("active");

                  iso.arrange({
                    filter: trigger.dataset.filter,
                  });
                });
              });
            }
          });
        }
      });
    }
  }

  hoverThumbs() {
    const elts = document.querySelectorAll(".hover-thumbs");

    if (elts) {
      elts.forEach((el) => {
        const triggers = el.querySelectorAll(".trigger");
        const thumbs = el.querySelector(".thumbs");
        let timer;

        if (triggers && thumbs) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("mouseenter", () => {
              clearTimeout(timer);
              gsap.set(trigger.closest("li"), {
                zIndex: 10,
              });
              gsap.to(thumbs, {
                autoAlpha: 1,
                scale: 1,
                duration: 0.2,
              });

              const target = thumbs.querySelector(
                `[data-target="${trigger.dataset.target}"]`
              );
              if (target) {
                gsap.fromTo(
                  target,
                  {
                    scale: 1.05,
                    autoAlpha: 0,
                  },
                  {
                    autoAlpha: 1,
                    scale: 1,
                    duration: 0.2,
                  }
                );
              }
            });

            trigger.addEventListener("mouseleave", () => {
              gsap.set(trigger.closest("li"), {
                zIndex: "initial",
              });

              const target = thumbs.querySelector(
                `[data-target="${trigger.dataset.target}"]`
              );
              if (target) {
                gsap.to(target, {
                  autoAlpha: 0,
                  duration: 0.2,
                });
              }

              timer = setTimeout(() => {
                gsap.to(thumbs, {
                  autoAlpha: 0,
                  scale: 0.9,
                  duration: 0.2,
                });
              }, 100);
            });
          });

          el.addEventListener("mousemove", (e) => {
            gsap.set(thumbs, {
              left: e.clientX,
              top: e.clientY,
            });
          });

          window.addEventListener("scroll", () => {
            gsap.to(thumbs, {
              autoAlpha: 0,
              scale: 0.9,
              duration: 0.2,
            });
          });
        }
      });
    }
  }

  randomizeFocus() {
    const elts = document.querySelectorAll(".randomize-focus");

    if (window.innerWidth < 992) return;

    if (elts) {
      elts.forEach((el) => {
        const cards = el.querySelectorAll(".card");
        const coords = [
          {
            rotation: -2,
          },
          {
            rotation: 0,
          },
          {
            rotation: 2,
          },
          {
            rotation: -2,
          },
        ];

        const containerW = el.clientWidth;
        const cardsLength = cards.length;
        let currentPortion = 0;
        const cardContent = el.querySelectorAll(".card .card-content");

        // el.addEventListener('in-view', () => {
        //   cards.forEach((card,i) => {
        //     gsap.fromTo(card,
        //       {
        //         scale: 1.2,
        //         autoAlpha: 0
        //       },
        //       {
        //         xPercent: coords[i%4].xPercent,
        //         yPercent: coords[i%4].yPercent,
        //         rotation : coords[i%4].rotation,
        //         autoAlpha: 1
        //       }
        //     );
        //       // gsap.set(card, {
        //       //     xPercent: (Math.random() - 0.5) * 20,
        //       //     yPercent: (Math.random() - 0.5) * 15,
        //       //     rotation: (Math.random() - 0.5) * 10,
        //       // })
        //   })
        // })

        cards.forEach((card, i) => {
          gsap.set(card, coords[i % 4]);
        });

        function resetPortion(index) {
          const opts = {
            xPercent: (Math.random() - 0.5) * 5,
            yPercent: (Math.random() - 0.5) * 5,
            rotation: (Math.random() - 0.5) * 6,
            scale: 1,
            duration: 0.8,
            ease: "elastic.out(1, 0.75)",
          };
          // Last active card
          gsap.to(cards[index], opts);
        }

        function newPortion(i) {
          gsap.to(cards[i], {
            // Reset transformation attributes
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            duration: 0.8,
            scale: 1.05,
            ease: "elastic.out(1, 0.75)", // Elastic movement at the end (out)
          });

          // For each card's child element
          cardContent.forEach((cardContent, index) => {
            // If it's not the active card
            if (index !== i) {
              gsap.to(cardContent, {
                // When index - i < 0, push left
                // When index - i > 0, push right
                // The further (index - i) moves from 0 in both ways,
                // the smaller the displacement
                xPercent: 23 / (index - i),
                ease: "elastic.out(1, 0.75)",
                duration: 0.8,
              });
              // If it is the active card
            } else {
              // Center its child
              gsap.to(cardContent, {
                xPercent: 0,
                ease: "elastic.out(1, 0.75)",
                duration: 0.8,
              });
            }
          });
        }

        el.addEventListener("mousemove", (e) => {
          // Cursor position relative to the left edge of the container
          const mouseX = e.clientX - el.getBoundingClientRect().left;

          // Cursor’s horizontal percentage within the container
          const percentage = mouseX / containerW;

          // Round the value up to get a valid index
          const activePortion = Math.ceil(percentage * cardsLength);

          // If a new portion is hovered
          if (
            currentPortion !== activePortion &&
            activePortion > 0 &&
            activePortion <= cardsLength
          ) {
            // If a portion was already hovered, reset it
            // -1 to target the correct index in the card set
            if (currentPortion !== 0) {
              resetPortion(currentPortion - 1);
            }

            // Update the index of the new portion
            currentPortion = activePortion;
            // -1 to target the correct index in the card set
            newPortion(currentPortion - 1);
          }
        });

        el.addEventListener("mouseleave", () => {
          // -1 to target the correct index in the card set
          resetPortion(currentPortion - 1);

          // No portion is hovered anymore
          currentPortion = 0;
          // Recenter all direct child elements of the cards
          gsap.to(cardContent, {
            xPercent: 0,
            ease: "elastic.out(1, 0.75)",
            duration: 0.8,
          });
        });
      });
    }
  }

  gifAnimation() {
    const elts = document.querySelectorAll(".gif-animation");

    if (elts) {
      elts.forEach((el, key) => {
        const delay = 0.07;
        const frames = el.querySelectorAll(".img");

        let currentFrame = 0;

        const tl = gsap
          .timeline({
            repeat: -1,
            repeatDelay: 0,
            delay: key * delay,
            paused: false,
          })
          .add(() => {
            frames.forEach((frame, index) => {
              const img = frame.querySelector("img");
              frame.style.visibility =
                index === currentFrame &&
                (img.classList.contains("loaded") || index == 0)
                  ? "visible"
                  : "hidden";
            });
            currentFrame = (currentFrame + 1) % frames.length; // Passer au frame suivant
          }, 0)
          .to({}, { duration: 0.2 }); // Pause entre les frames
      });
    }
  }

  tabs() {
    const elts = document.querySelectorAll(".tabs");

    if (elts) {
      elts.forEach((el) => {
        const content = el.querySelector(".tabs-content");
        const triggers = el.querySelectorAll(".tabs-header a");
        const select = el.querySelector(".tabs-select");
        const items = el.querySelectorAll(".tabs-item");

        if (content && triggers.length > 1 && items.length > 1) {
          let current = -1;

          window.addEventListener("resize", () => {
            const el = items[current] ? items[current] : items[0];
            gsap.to(content, {
              height: el.scrollHeight,
              duration: 0.3,
              ease: "circ.inOut",
            });
          });

          window.dispatchEvent(new Event("resize"));

          function goto(index) {
            let delay = 0;
            const dir = current > index ? -1 : 1;

            el.style.pointerEvents = "none";

            if (items[current]) {
              gsap.to(items[current], {
                position: "absolute",
                x: `${-dir * 15}%`,
                autoAlpha: 0,
                duration: 0.5,
                ease: "circ.in",
              });

              triggers[current].classList.remove("active");

              delay = 0.5;
            }

            if (items[index]) {
              gsap.fromTo(
                items[index],
                {
                  x: `${dir * 15}%`,
                  autoAlpha: 0,
                  position: "absolute",
                },
                {
                  autoAlpha: 1,
                  x: "0%",
                  duration: 0.5,
                  ease: "circ.out",
                  delay,
                  onStart: () => {
                    el.style.pointerEvents = "auto";
                  },
                }
              );
              triggers[index].classList.add("active");
            }

            current = index;
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, delay * 1000 * 0.5);
          }

          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              if (trigger.classList.contains("active")) return;
              goto(i);
            });
          });

          el.addEventListener("inview", () => {
            if (!el.classList.contains("is-visible")) goto(0);
          });

          if (select) {
            select.addEventListener("change", () => {
              goto(select.value);
            });
          }
        }
      });
    }
  }

  multipleTabs() {
    const elts = document.querySelectorAll(".multiple-tabs");

    if (elts) {
      elts.forEach((el) => {
        const content = el.querySelector(".tabs-level1");
        const triggers = el.querySelectorAll(".tabs-level1-header a");
        const items = el.querySelectorAll(".tabs-level1-item");
        const select = el.querySelector(".tabs-level1-select");
        let current = -1;

        if (content && triggers && items) {
          window.addEventListener("resize", () => {
            const el = items[current] ? items[current] : items[0];
            gsap.to(content, {
              height: el.scrollHeight,
              duration: 0.3,
              ease: "circ.inOut",
            });
          });

          window.dispatchEvent(new Event("resize"));

          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              if (trigger.classList.contains("active")) return;
              goto(i);
            });
          });

          function goto(index) {
            let delay = 0;

            el.style.pointerEvents = "none";

            if (items[current]) {
              gsap.to(items[current], {
                autoAlpha: 0,
                y: "-3rem",
                duration: 0.5,
                ease: "power2.in",
              });

              triggers[current].classList.remove("active");

              delay = 0.5;
            }

            if (items[index]) {
              gsap.fromTo(
                items[index],
                {
                  autoAlpha: 0,
                  y: "3rem",
                  position: "absolute",
                },
                {
                  autoAlpha: 1,
                  y: "0rem",
                  duration: 0.5,
                  ease: "power2.out",
                  delay,
                  onStart: () => {
                    el.style.pointerEvents = "auto";
                  },
                  onComplete: () => {
                    const delays = el.querySelectorAll('[class*="delay-"]');

                    if (delays && delays.length > 1) {
                      delays.forEach((d) => {
                        d.classList.remove(
                          "delay-100",
                          "delay-200",
                          "delay-300"
                        );
                      });
                    }
                  },
                }
              );

              triggers[index].classList.add("active");
            }

            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, delay * 1000 * 0.5);

            current = index;
          }
          if (select) {
            select.addEventListener("change", () => {
              goto(select.value);
            });
          }

          el.addEventListener("inview", () => {
            if (!el.classList.contains("is-visible")) goto(0);
          });
        }
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const triggers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");

        if (triggers && contents) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              trigger.classList.toggle("open");

              gsap.to(contents[i], {
                autoAlpha: trigger.classList.contains("open") ? 1 : 0,
                height: trigger.classList.contains("open")
                  ? contents[i].scrollHeight
                  : 0,
                ease: "circ.inOut",
                duration: 0.3,
              });
            });
          });
        }
      });
    }
  }

  parallaxHover() {
    const elts = document.querySelectorAll("[data-parallax]");

    if (elts) {
      elts.forEach((el) => {
        const inners = el.querySelectorAll("[data-parallax-move]");

        el.addEventListener("mousemove", (e) => {
          const rect = el.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          // Normalisation entre -1 et 1
          const xNorm = (x / rect.width) * 2 - 1;
          const yNorm = (y / rect.height) * 2 - 1;

          inners.forEach((inner) => {
            // Valeurs max de déplacement (en %)
            const maxMove =
              ((inner.dataset.parallaxMove ? inner.dataset.parallaxMove : 1) /
                100) *
              Number.parseFloat(el.offsetWidth);

            gsap.to(inner, {
              x: xNorm * maxMove,
              y: yNorm * maxMove,
              duration: 0.4,
              ease: "power2.out",
            });
          });
        });

        el.addEventListener("mouseleave", () => {
          inners.forEach((inner) => {
            gsap.to(inner, {
              x: 0,
              y: 0,
              duration: 0.6,
              ease: "power3.out",
            });
          });
        });
      });
    }
  }

  marquee() {
    const _ = this;
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        let direction = track.dataset.dir ? track.dataset.dir : -1; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;

        function computeWrapWidth() {
          _.lazyload.update();
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            if (
              track.dataset.changeDir == undefined ||
              (track.dataset.changeDir && track.dataset.changeDir == "false")
            )
              return;

            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
              // Scroll vers le bas → texte va vers la gauche
              direction = Number(track.dataset.dir);
            } else if (currentScrollY < lastScrollY) {
              // Scroll vers le haut → texte va vers la droite
              direction = -1 * track.dataset.dir;
            }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        gsap.ticker.add(() => {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        });
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
